import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { TouchableOpacity } from "react-native";

export default function HowtoUseJournalIcon(props) {
  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M22.0428 5.98585C21.7742 5.65565 21.3856 5.44542 20.9622 5.40126C20.5388 5.3571 20.1152 5.4826 19.7841 5.75025L10.145 13.566C10.058 13.6321 9.99071 13.7206 9.95038 13.8221L8.92603 16.3215C8.91017 16.361 8.90421 16.4038 8.90866 16.4462C8.91311 16.4885 8.92784 16.5291 8.95157 16.5645C8.97531 16.5998 9.00732 16.6288 9.04482 16.649C9.08232 16.6691 9.12418 16.6798 9.16675 16.6801H9.21285L11.871 16.2037C11.9778 16.184 12.0781 16.1383 12.163 16.0706L21.8072 8.24967C22.1378 7.9801 22.3481 7.59062 22.3923 7.16639C22.4364 6.74216 22.3108 6.3177 22.0428 5.98585V5.98585Z"
          fill="url(#paint0_linear_how_to_journal)"
        />
        <Path
          d="M15.3021 15.2509V18.1037C15.3048 18.2596 15.2765 18.4146 15.2188 18.5596C15.1612 18.7045 15.0753 18.8366 14.9662 18.9481C14.8571 19.0596 14.7269 19.1483 14.5832 19.2091C14.4395 19.2699 14.2852 19.3015 14.1292 19.3022H6.26219C5.95112 19.3022 5.65279 19.1786 5.43284 18.9586C5.21288 18.7387 5.08931 18.4403 5.08931 18.1293V6.26219C5.08863 6.10797 5.1185 5.95515 5.17721 5.81254C5.23591 5.66994 5.32228 5.54037 5.43132 5.43132C5.54037 5.32228 5.66994 5.23591 5.81254 5.17721C5.95515 5.1185 6.10797 5.08863 6.26219 5.08931H14.1292C14.4403 5.08931 14.7386 5.21288 14.9585 5.43284C15.1785 5.65279 15.3021 5.95112 15.3021 6.26219V7.65018L17.9142 5.5349C17.7462 4.65381 17.2764 3.85882 16.5856 3.28672C15.8948 2.71462 15.0261 2.4012 14.1292 2.40039H6.26219C5.23839 2.40175 4.25692 2.80905 3.53298 3.53298C2.80905 4.25692 2.40175 5.23839 2.40039 6.26219L2.40039 18.1037C2.40175 19.1275 2.80905 20.1089 3.53298 20.8329C4.25692 21.5568 5.23839 21.9641 6.26219 21.9655H14.1292C15.153 21.9641 16.1345 21.5568 16.8584 20.8329C17.5823 20.1089 17.9896 19.1275 17.991 18.1037V13.0741L15.3021 15.2509Z"
          fill="url(#paint1_linear_how_to_journal)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_how_to_journal"
            x1="8.90723"
            y1="7.84047"
            x2="13.7323"
            y2="19.6266"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_how_to_journal"
            x1="2.40039"
            y1="6.64342"
            x2="13.0379"
            y2="23.9636"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
